import { defineComponent, onMounted } from 'vue';
import OverviewCode from '@/presentation/pages/overview/overview.code';

export default defineComponent({
	setup: () => {
		const code = new OverviewCode();

		onMounted(code.prepareUploads.bind(code));

		return {
			storedImports: code.storedImports,
			doesAmountOfImportsExceedLimit: code.doesAmountOfImportsExceedLimit,
			shouldEntryBeShown: code.shouldEntryBeShown.bind(code),
			shouldRefreshButtonBeShown: code.shouldRefreshButtonBeShown.bind(code),
			shouldErrorDetailsButtonBeShown: code.shouldErrorDetailsButtonBeShown.bind(code),
			getLabelOfStatus: code.getLabelOfStatus.bind(code),
			convertTimestampToDateString: code.convertTimestampToDateString.bind(code),
			increaseLimit: code.increaseLimit.bind(code),
			updateStatus: code.updateStatus.bind(code),
			showErrorDetails: code.showErrorDetails.bind(code)
		};
	}
});
